import React, { useEffect, useState } from "react";
import axios from "axios";
import { Box, Button, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import API_URL from "../../config";
import DocumentCard from "../../components/DocumentCard/DocumentCard";
import API_BASE_URL from "../../utils/api";

const CategorizedDocuments = () => {
  const { category, subcategory } = useParams();
  const [documents, setDocuments] = useState([]);

  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    let isMounted = true;

    const fetchDocs = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("token");

        const url = token
          ? `${API_BASE_URL}/documents`
          : `${API_BASE_URL}/documents/public/documents`;

        const headers = token ? { Authorization: `Bearer ${token}` } : {};

        const res = await axios.get(url, { headers });

        const filteredDocs = res.data.filter((doc) => {
          const sameCategory = doc.category === category;

          if (subcategory) {
            return sameCategory && (doc.subcategory || "") === subcategory;
          }
          return sameCategory;
        });

        if (isMounted) setDocuments(filteredDocs);
      } catch (err) {
        console.error("Error fetching categorized docs:", err);
        if (isMounted) setDocuments([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchDocs();

    return () => {
      isMounted = false;
    };
  }, [category, subcategory]);

  const heading = subcategory
    ? `Documents in ${category} / ${subcategory}`
    : `Documents in ${category}`;

  return (
    <Box
      sx={{
        width: "auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Box sx={{ display: "flex", gap: 2, mt: 1, mb: 2 }}>
        <Button variant="outlined" onClick={() => navigate(`/transcription`)}>
          View All Documents
        </Button>

        {subcategory && (
          <Button
            variant="outlined"
            onClick={() => navigate(`/transcription/category/${category}`)}
          >
            Back to {category}
          </Button>
        )}
      </Box>

      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
          paddingBottom: "5px",
        }}
      >
        {heading}
      </Typography>

      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          gap: "20px",
          marginTop: "10px",
        }}
      >
        {loading ? (
          <Typography>Loading…</Typography>
        ) : documents.length > 0 ? (
          documents.map((doc) => (
            <DocumentCard key={doc.documentId} doc={doc} />
          ))
        ) : (
          <Typography>No active documents.</Typography>
        )}
      </Box>
    </Box>
  );
};

export default CategorizedDocuments;
